import React, { useState } from 'react';
import AppModal from '../../common/AppModal';
import { FiFileText, FiEye, FiTrash2, FiEdit2, FiPlus } from 'react-icons/fi';

const btnPrimary = {
  padding: '8px 20px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#fff',
  backgroundColor: '#1a7d3e',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  boxShadow: '0 2px 6px rgba(26, 125, 62, 0.3)',
};

const btnSecondary = {
  padding: '8px 20px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#1a7d3e',
  backgroundColor: '#fff',
  border: '1.5px solid #1a7d3e',
  borderRadius: '8px',
  cursor: 'pointer',
};

const InternalNotesWithTabs = ({
  notes,
  newTitle,
  setNewTitle,
  newDescription,
  setNewDescription,
  handleAddNote,
  handleEditNote,
  deleteNote,
}) => {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [editNote, setEditNote] = useState({ id: null, title: '', description: '' });

  const openViewModal = (description) => {
    setSelectedDescription(description);
    setShowViewModal(true);
  };

  const openEditModal = (note) => {
    setEditNote({ id: note.id, title: note.notes || '', description: note.description || '' });
    setShowEditModal(true);
  };

  const handleAdd = () => {
    handleAddNote();
    setShowAddModal(false);
  };

  const handleEdit = () => {
    handleEditNote(editNote.id, editNote.title, editNote.description);
    setShowEditModal(false);
  };

  return (
    <div className="internal-notes">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
        <button
          type="button"
          className="internal-notes-add-btn"
          style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
          onClick={() => {
            setNewTitle('');
            setNewDescription('');
            setShowAddModal(true);
          }}
        >
          <FiPlus size={15} />
          Add
        </button>
      </div>

      <div className="internal-notes-table-card">
        <table className="internal-notes-table">
          <thead>
            <tr>
              <th>Note</th>
              <th>Created By</th>
              <th>Date</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {notes.map((note) => (
              <tr key={note.id}>
                <td className="internal-notes-table__note">{note.notes || 'Untitled'}</td>
                <td>{note?.User?.name || 'N/A'}</td>
                <td>{new Date(note.createdAt).toLocaleDateString()}</td>
                <td>
                  <button
                    type="button"
                    className="internal-notes-view-btn"
                    onClick={() => openViewModal(note.description)}
                  >
                    <FiEye size={14} />
                    View
                  </button>
                </td>
                <td style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button
                    type="button"
                    className="internal-notes-edit-btn"
                    onClick={() => openEditModal(note)}
                    title="Edit"
                  >
                    <FiEdit2 size={15} />
                  </button>
                  <button
                    type="button"
                    className="internal-notes-delete-btn"
                    onClick={() => deleteNote(note.id)}
                    title="Delete"
                  >
                    <FiTrash2 size={15} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add Note Modal */}
      <AppModal
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
        icon={<FiFileText size={17} color="#fff" />}
        title="Add Note"
        subtitle="Create a new internal note"
        maxWidth="520px"
        footer={
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button type="button" style={btnSecondary} onClick={() => setShowAddModal(false)}>
              Cancel
            </button>
            <button
              type="button"
              style={btnPrimary}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
              onClick={handleAdd}
            >
              Add
            </button>
          </div>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div className="internal-notes-field">
            <label htmlFor="add-note-title">Title</label>
            <input
              id="add-note-title"
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              placeholder="Title"
              className="internal-notes-input"
            />
          </div>
          <div className="internal-notes-field">
            <label htmlFor="add-note-description">Description</label>
            <textarea
              id="add-note-description"
              value={newDescription}
              onChange={(e) => setNewDescription(e.target.value)}
              placeholder="Take a note..."
              className="internal-notes-textarea"
              rows={4}
            />
          </div>
        </div>
      </AppModal>

      {/* Edit Note Modal */}
      <AppModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        icon={<FiEdit2 size={17} color="#fff" />}
        title="Edit Note"
        subtitle="Update internal note"
        maxWidth="520px"
        footer={
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button type="button" style={btnSecondary} onClick={() => setShowEditModal(false)}>
              Cancel
            </button>
            <button
              type="button"
              style={btnPrimary}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
              onClick={handleEdit}
            >
              Save
            </button>
          </div>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div className="internal-notes-field">
            <label htmlFor="edit-note-title">Title</label>
            <input
              id="edit-note-title"
              type="text"
              value={editNote.title}
              onChange={(e) => setEditNote((prev) => ({ ...prev, title: e.target.value }))}
              placeholder="Title"
              className="internal-notes-input"
            />
          </div>
          <div className="internal-notes-field">
            <label htmlFor="edit-note-description">Description</label>
            <textarea
              id="edit-note-description"
              value={editNote.description}
              onChange={(e) => setEditNote((prev) => ({ ...prev, description: e.target.value }))}
              placeholder="Take a note..."
              className="internal-notes-textarea"
              rows={4}
            />
          </div>
        </div>
      </AppModal>

      {/* View Description Modal */}
      <AppModal
        show={showViewModal}
        onClose={() => setShowViewModal(false)}
        icon={<FiFileText size={17} color="#fff" />}
        title="Description"
        subtitle="Internal note details"
        maxWidth="520px"
        footer={
          <button
            type="button"
            style={btnPrimary}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
            onClick={() => setShowViewModal(false)}
          >
            Close
          </button>
        }
      >
        {selectedDescription && selectedDescription.trim() ? (
          <pre className="internal-notes-view-content">{selectedDescription}</pre>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              minHeight: '120px',
              background: '#f5f7f6',
              borderRadius: '8px',
              border: '1px dashed #d1d5db',
              padding: '24px 16px',
            }}
          >
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="9" y1="17" x2="12" y2="17" />
            </svg>
            <p style={{ margin: 0, fontSize: '13.5px', color: '#6b7280', fontWeight: 500 }}>
              No description provided
            </p>
            <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>
              This note does not have any description yet.
            </p>
          </div>
        )}
      </AppModal>
    </div>
  );
};

export default InternalNotesWithTabs;
